import React from "react";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import { camelize } from "humps";
/**
 * add account owner as employeeName to conform to pageFields[].format of "${ '@user.employeeName'}"
 *
 * @param  {Array}  accounts [description]
 * @param  {[type]} login    [description]
 * @return {[type]}          [description]
 */
export const enrichAccounts = (accounts = [], login) =>
  accounts.map(account => ({
    ...account,
    user: {
      employeeName: account.owner || login.user.employee.fullName,
    },
  }));

export const renderRejectedFiles = files =>
  files && files.length ? (
    <div className="field__error rejected-file-error-message">
      <FormattedMessage {...messages.uploadImageLimitationDescription} />
    </div>
  ) : null;

const _TYPES = {
  CURRENCY: "Currency",
  DATE: "Date",
  LINK: "Link",
};
export const TYPES = {
  ..._TYPES,
  isDate: v => camelize(v) === _TYPES.DATE,
  isLink: v => camelize(v) === _TYPES.LINK,
};

export const showEstimatedDateMessage = pageFields =>
  pageFields.find(o => o.fieldID === "EstimatedPaymentDate");

const BASE64_MARKER = ";base64,";

const dataURItoJPG = (dataURI, name) => {
  // Format of a base64-encoded URL:
  // data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYAAAAEOCAIAAAAPH1dAAAAK
  let mime = dataURI.split(BASE64_MARKER)[0].split(":")[1];
  // let filename = 'dataURI-file-' + (new Date()).getTime() + '.' + mime.split('/')[1];
  let fileName = name + ".jpeg";
  let bytes = atob(dataURI.split(BASE64_MARKER)[1]);
  let writer = new Uint8Array(new ArrayBuffer(bytes.length));

  for (let i = 0; i < bytes.length; i++) {
    writer[i] = bytes.charCodeAt(i);
  }
  return new File([writer.buffer], fileName, { type: mime });
};

export const resizeImage = (file, fileList, onChange) => {
  let fileSize = (file.size / 1024 / 1024).toFixed(4); // MB
  if (fileSize < 2) {
    fileList && Array.isArray(fileList) && fileList.push(file);
    onChange && onChange(fileList);
  } else {
    let rate = 2 / (fileSize * 2);
    if (fileSize < 6) {
      rate = 2 / (fileSize * 4);
    } else if (fileSize < 8) {
      rate = 2 / (fileSize * 3);
    }
    let image = new Image();
    image.src = file.preview;
    image.onload = () => {
      let canvas = document.createElement("canvas");

      let width = image.width;
      let height = image.height;

      canvas.width = width;
      canvas.height = height;

      let ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, width, height);
      let resized = canvas.toDataURL("image/jpeg", rate);
      let resizedFile = dataURItoJPG(resized, file.name);
      resizedFile.preview = file.preview;
      fileList && Array.isArray(fileList) && fileList.push(resizedFile);
      onChange && onChange(fileList);
    };
  }
};

export function addDays(days) {
  const currentDate = new Date(); // Get the current date
  currentDate.setDate(currentDate.getDate() + days); // Add the days

  // Extract day, month, and year
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = currentDate.getFullYear();

  // Return the formatted date as "dd/mm/yyyy"
  return `${day}/${month}/${year}`;
}



// WEBPACK FOOTER //
// ./components/claim/util.js